import { Facet } from '../models/Facet';
import { IActivity, IIncompleteData, IKeyPointsData, ILifeCycleStatus } from '../models/ItemAnalytics';

/**
 * Facet which represent the item is trending or not.
 */
export const isTrendingFacet: Facet<boolean> = new Facet('isTrending');

/**
 * Facet which represent how many times the item is viewed.
 */
export const viewCountFacet: Facet<number> = new Facet('viewCount');

/**
 * Facet which represent how many users viewed this item.
 */
export const viewerCountFacet: Facet<number> = new Facet('viewerCount');

/**
 * Facet which represent how many times the item is liked.
 */
export const likeCountFacet: Facet<number> = new Facet('likeCount');

/**
 * Facet which represent how many comments are on this item.
 */
export const commentCountFacet: Facet<number> = new Facet('commentCount');

/**
 * Facet which represent view activities on this item.
 */
export const activitiesFacet: Facet<IActivity[]> = new Facet('activities');

/**
 * Facet which represent key points on this item.
 */
export const keyPointsFacet: Facet<IKeyPointsData> = new Facet('keyPoints');

/**
 * Facet which represent lifecycle status on this item.
 */
export const lifeCycleStatusFacet: Facet<ILifeCycleStatus[]> = new Facet('lifeCycleStatus');

/**
 * Facet which represent view activities on this item.
 */
export const incompleteDataFacet: Facet<IIncompleteData> = new Facet('incompleteData');